import { Stack, Typography } from '@mui/material';

import Image from '../../Images/picturePlaceholder.png';

function PublicMember(props) {

    const imgURL = props?.imgURL ? process.env.REACT_APP_API_HOST + "/" + props.imgURL : Image;
    const memberName = props?.name || 'Member Name';

    return (
        <Stack spacing={1} sx={{justifyContent: "center", alignItems: 'center', py:3, textAlign: "center", p: 2}}>
            <img src={imgURL} alt={props.name || 'placeholder'} width='80%' style={{borderRadius: "50%", aspectRatio: "1 / 1", objectFit: "cover"}}/>
            <Typography variant='h5' sx={{fontSize: '1.75rem'}}>{memberName}</Typography>
        </Stack>
    );
}

export default PublicMember;